import { useLazyQuery } from '@apollo/client';
import { message } from 'antd';
import {
    QUERY_PRICING_BY_TRACKING_NUMBER,
    QUERY_PRICING_BY_CONDITION,
    QueryPricingByTrackingNumberResponse,
    QueryPricingByTrackingNumberVariables,
    QueryPricingByConditionResponse,
    QueryPricingByConditionVariables,
    QueryPricingByTrackingNumberInput,
    QueryPricingByConditionInput,
    QueryPricingResult
} from '../graphql/mutations/pricingQueryMutations';

/**
 * 使用根据运单号查询计费信息功能
 */
export const useQueryPricingByTrackingNumber = () => {
    const [queryPricingByTrackingNumber, { loading: trackingLoading }] = useLazyQuery<
        QueryPricingByTrackingNumberResponse,
        QueryPricingByTrackingNumberVariables
    >(QUERY_PRICING_BY_TRACKING_NUMBER);

    const executeQueryPricingByTrackingNumber = async (input: QueryPricingByTrackingNumberInput): Promise<QueryPricingResult | null> => {
        try {
            const { data } = await queryPricingByTrackingNumber({
                variables: { input }
            });
            
            const result = data?.queryPricingByTrackingNumber;
            if (result?.success) {
                message.success(result.message);
                return result;
            } else {
                message.error(result?.message || '查询失败');
                return result || null;
            }
        } catch (error) {
            console.error('查询计费信息错误:', error);
            message.error('查询失败');
            return null;
        }
    };

    return {
        executeQueryPricingByTrackingNumber,
        loading: trackingLoading
    };
};

/**
 * 使用按条件分页查询计费结果
 */
export const useQueryPricingByCondition = () => {
    const [queryPricingByCondition, { loading: conditionLoading }] = useLazyQuery<
        QueryPricingByConditionResponse,
        QueryPricingByConditionVariables
    >(QUERY_PRICING_BY_CONDITION);

    const executeQueryPricingByCondition = async (input: QueryPricingByConditionInput): Promise<QueryPricingResult | null> => {
        try {
            const { data } = await queryPricingByCondition({
                variables: { input }
            });
            const result = data?.queryPricingByCondition;
            if (result?.success) {
                message.success(result.message);
                return result;
            } else {
                message.error(result?.message || '查询失败');
                return result || null;
            }
        } catch (error) {
            console.error('按条件查询计费信息错误:', error);
            message.error('查询失败');
            return null;
        }
    };

    return {
        executeQueryPricingByCondition,
        loading: conditionLoading
    };
};

/**
 * 组合使用所有查询功能的hook
 */
export const usePricingQuery = () => {
    const queryByTrackingNumber = useQueryPricingByTrackingNumber();
    const queryByCondition = useQueryPricingByCondition();

    return {
        queryByTrackingNumber,
        queryByCondition,
        loading: queryByTrackingNumber.loading || queryByCondition.loading
    };
};
